<template>
  <div>
    <van-notice-bar :text="titleInfo" color="#1989fa" background="#ecf9ff" left-icon="medel-o"/>
    <!--    <div id="he-plugin-standard"></div>-->
    <van-divider :style="{ color: '#2196f3', borderColor: '#2196f3', padding: '0 16px' }">
      我的工作台
    </van-divider>
    <van-grid clickable icon-size="40px" direction="horizontal" :column-num="2" style="color: #2196f3;">
      <van-grid-item icon="records" text="我的待办" to="/attenceflow/FlowList" :badge="auditCount" v-if="auditCount > 0"/>
      <van-grid-item icon="records" text="我的待办" to="/attenceflow/FlowList" v-else/>
      <van-grid-item icon="bullhorn-o" text="通知公告" to="/attenceflow/notice/list" :badge="noticeCount"
                     v-if="noticeCount > 0"/>
      <van-grid-item icon="bullhorn-o" text="通知公告" to="/attenceflow/notice/list" v-else/>
    </van-grid>
    <van-divider :style="{ color: '#2196f3', borderColor: '#2196f3', padding: '0 16px' }">
      常用应用
    </van-divider>
    <van-grid clickable :column-num="3" style="color: #2196f3;">
      <van-grid-item icon="location-o" text="移动考勤" v-if="this.userInfo.userType == 1" style="color: #828787;"/>
      <van-grid-item icon="location-o" text="移动考勤" to="/attenceflow/lbsAttendance/list" v-else/>
      <van-grid-item icon="calendar-o" text="移动请假" to="/attenceflow/leave/list"/>
      <van-grid-item icon="close" text="移动销假" to="/attenceflow/holidayCancel/list"/>
      <van-grid-item icon="tosend" text="加班申请" to="/attenceflow/workovertime/list"/>
      <van-grid-item icon="warn-o" text="考勤申诉" to="/attenceflow/userAttenceErrAppeal/list"/>
      <van-grid-item icon="logistics" text="外出办事" to="/attenceflow/away/list"/>
      <van-grid-item icon="todo-list-o" text="离开本市" to="/attenceflow/userOutCity/list"/>
      <van-grid-item icon="underway-o" text="考勤查询" to="/attenceflow/query/list"/>
      <van-grid-item icon="setting-o" text="外出销假" to="/attenceflow/awayCancel/list"/>
    </van-grid>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="friends-o" @click="jumpPage">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

import {Toast} from "vant";
import {isWechat} from "../../utils/util";

export default {
  name: "AttenceHome",
  data() {
    return {
      active: 0,
      screenWidth: document.body.clientWidth,
      auditCount: 0,
      noticeCount: 0,
      userInfo: {},
      titleInfo: '',
    };
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    window.WIDGET = {
      "CONFIG": {
        "layout": "1",
        "width": this.screenWidth,
        "height": "150",
        "background": "1",
        "dataColor": "FFFFFF",
        "city": "CN101190101",
        "key": "451c6d4c11354995bc6d534ea460156d"
      }
    };
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0";
    document.getElementsByTagName('head')[0].appendChild(script);
    this.getAttenceFlowList();
    this.getNoticeList();
    this.getUserInfo();
  },
  methods: {
    dateDiff(sDate1) {
      const date2 = new Date();
      const date1 = new Date(Date.parse(sDate1.replace(/-/g, "/")));
      const iDays = parseInt(Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24);
      return iDays;
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.userInfo = user;
          const yearDate = new Date().getFullYear() + "-01-01";
          this.titleInfo = this.userInfo.realName + "您好！您已经为集团工作" + this.dateDiff(this.userInfo.hireDate) +
            "天，感谢您的辛勤付出！"
        }
      );
    },
    jumpPage: function () {
      this.$router.push({
        path: "/attenceflow/UserInfo",
        query: {}
      });
    },
    errorTip() {
      Toast.fail("功能开发中，敬请期待");
    },
    getAttenceFlowList: function () {
      this.$fetch("/attence-api/blade-flow/work/todowork-list", {
        current: 1,
        size: 500
      }).then(
        res => {
          const data = res.data;
          this.auditCount = data.total;
        }
      );
    },
    getNoticeList: function () {
      this.$fetch("/attence-api/blade-notices/notices/page", {
        current: 1,
        size: 10,
        type: 1,
        noticeStatus: 2,
        isDeleted: 0
      }).then(
        res => {
          const data = res.data;
          this.noticeCount = data.total;
        }
      );
    },
  }
}

</script>
<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/AttenceHome.vue